import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from '@/shared/components/ui/form/components/radio-group/radio-group';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { TDateTimeFormatProps } from '@/shared/features/header/components/date-time-format/date-time-format.types';

export const DateTimeFormatForm: React.FC<TDateTimeFormatProps> = ({
  handleClose,
}) => {
  const { t } = useTranslation();
  const referenceDate = new Date(new Date().getFullYear(), 11, 31, 13, 0); // December 31st of current year, 13:00

  const dateFormatOptions = [
    {
      value: 'dd/MM/yyyy',
      label: `${format(referenceDate, 'dd/MM/yyyy')}`,
    },
    {
      value: 'MM/dd/yyyy',
      label: `${format(referenceDate, 'MM/dd/yyyy')}`,
    },
    {
      value: 'yyyy-MM-dd',
      label: `${format(referenceDate, 'yyyy-MM-dd')}`,
    },
  ];

  const timeFormatOptions = [
    {
      value: 'HH:mm',
      label: `${format(referenceDate, 'HH:mm')}`,
    },
    {
      value: 'h:mm a',
      label: `${format(referenceDate, 'h:mm a')}`,
    },
  ];

  return (
    <FormContainer>
      <FormContent>
        <RadioGroup
          name={'dateFormat'}
          label={t('ui:date_format')}
          options={dateFormatOptions}
          required
          optionDirection="column"
        />
        <RadioGroup
          name={'timeFormat'}
          label={t('ui:time_format')}
          options={timeFormatOptions}
          required
          optionDirection="column"
        />
      </FormContent>
      <Submit
        submitButtonLabel={t('common:save_changes')}
        onClose={handleClose}
        formHasToBeDirty
      />
    </FormContainer>
  );
};
